import { render, staticRenderFns } from "./QuotaFilterEditor.vue?vue&type=template&id=f189ad2a&scoped=true&"
import script from "./QuotaFilterEditor.vue?vue&type=script&lang=js&"
export * from "./QuotaFilterEditor.vue?vue&type=script&lang=js&"
import style0 from "./QuotaFilterEditor.vue?vue&type=style&index=0&id=f189ad2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f189ad2a",
  null
  
)

export default component.exports